class SpaRenderer {
  constructor(canvas) {
    this.canvas = canvas;

    // Logical/display size
    this.width = 300;
    this.height = 300;

    // High-DPI / Retina support
    this.dpr = Math.max(1, window.devicePixelRatio || 1);

    // Visible canvas size
    this.canvas.style.width = `${this.width}px`;
    this.canvas.style.height = `${this.height}px`;

    // Internal bitmap resolution
    this.canvas.width = Math.round(this.width * this.dpr);
    this.canvas.height = Math.round(this.height * this.dpr);

    this.ctx = this.canvas.getContext("2d");

    // Keep all existing drawing coordinates working in 300x300
    this.ctx.setTransform(
      this.dpr,
      0,
      0,
      this.dpr,
      0,
      0
    );
  }

  render(data) {
    this.data = data || {};

    this.ctx.clearRect(
      0,
      0,
      this.width,
      this.height
    );

    this.calculateScale();

    this.drawShadow();
    this.drawTop();
    this.drawFold();
    this.drawDimensions();
  }

  number(value, fallback) {
    const parsed = Number(value);

    return Number.isFinite(parsed) && parsed > 0
      ? parsed
      : fallback;
  }

  getLayoutPadding() {
    const shape = this.data.shape || "roundedRectangle";

    if (shape === "circle") {
      return {
        left: 35,
        right: 35,
        top: 50,
        bottom: 65,
      };
    }

    if (shape === "square") {
      return {
        left: 70,
        right: 35,
        top: 50,
        bottom: 25,
      };
    }
    if (shape === "oval") {
    return { left: 60, right: 60, top: 55, bottom: 25 };
  }

    return {
      left: 70,
      right: 60,
      top: 55,
      bottom: 25,
    };
  }

  calculateScale() {
    const frame = this.getShapeFrame();

    const safeWidth = this.number(frame.width, 84);
    const safeHeight = this.number(frame.height, 90);

    const padding = this.getLayoutPadding();

    const canvasWidth =
      Number.isFinite(this.width) && this.width > 0
        ? this.width
        : 300;

    const canvasHeight =
      Number.isFinite(this.height) && this.height > 0
        ? this.height
        : 300;

    const maxWidth = Math.max(
      1,
      canvasWidth - padding.left - padding.right
    );

    const maxHeight = Math.max(
      1,
      canvasHeight - padding.top - padding.bottom
    );

    this.scale = Math.min(
      maxWidth / safeWidth,
      maxHeight / safeHeight
    );

    if (
      !Number.isFinite(this.scale) ||
      this.scale <= 0
    ) {
      this.scale = 1;
    }

    this.w = safeWidth * this.scale;
    this.h = safeHeight * this.scale;

    this.r =
      this.number(frame.radius, 0) *
      this.scale;

    this.offset =
      this.number(frame.offset, 0) *
      this.scale;

    this.edge =
      this.number(frame.edge, 0) *
      this.scale;

    this.cutOffset =
      this.number(frame.cutOffset, 0) *
      this.scale;

    if (this.data.shape === "circle") {
      const diameter = Math.min(
        this.w,
        this.h
      );

      this.w = diameter;
      this.h = diameter;
    }

    const drawingWidth =
      this.w +
      padding.left +
      padding.right;

    const drawingHeight =
      this.h +
      padding.top +
      padding.bottom;

    this.x =
      (canvasWidth - drawingWidth) / 2 +
      padding.left;

    this.y =
      (canvasHeight - drawingHeight) / 2 +
      padding.top;

    if (this.data.shape === "circle") {
      this.x =
        (canvasWidth - this.w) / 2;

      this.y =
        (canvasHeight - this.h) / 2 - 20;
    }

    if (
      ![
        this.w,
        this.h,
        this.r,
        this.offset,
        this.edge,
        this.cutOffset,
        this.x,
        this.y
      ].every(Number.isFinite)
    ) {
   

      this.w = 100;
      this.h = 100;
      this.r = 0;
      this.offset = 0;
      this.edge = 0;
      this.cutOffset = 0;

      this.x = 100;
      this.y = 100;
    }
  }

  getShapeFrame() {
    const shape = this.data.shape || "roundedRectangle";

    if (shape === "circle") {
      const diameter = this.number(this.data.A, 84);

      return {
        width: diameter,
        height: diameter
      };
    }

    if (shape === "square") {
      const side = this.number(this.data.A, 84);

      return {
        width: side,
        height: side
      };
    }

    if (shape === "octagon") {
      const A = this.number(this.data.A, 84);
      const B = this.number(this.data.B, 12);

      const offset = B / Math.sqrt(2);

      return {
        width: A + offset * 2,
        height: A + offset * 2,
        offset,
        edge: B,
      };
    }

    if (shape === "oneCut") {
      return {
        width: this.number(this.data.A, 0),
        height: this.number(this.data.B, 0),
        cutOffset: this.number(this.data.C, 0),
      };
    }
      if (shape === "oval") {
          const A = this.number(this.data.A, 0);
          const B = this.number(this.data.B, 0);


          const OVAL_MIN_RATIO = 1.18; 

          let width = A;
          let height = B;

          if (width > 0 && height > 0 && height / width < OVAL_MIN_RATIO) {
            height = width * OVAL_MIN_RATIO;
          }

          return { width, height };
        }

    return {
      width: this.number(this.data.A, 0),
      height: this.number(this.data.B, 0),

      radius:
        shape === "roundedRectangle" ||
        shape === "roundedSquare"
          ? this.number(this.data.C, 0)
          : 0,
    };
  }

  roundedPath(ctx, x, y, w, h, r) {
    r = Math.max(
      0,
      Math.min(
        r,
        Math.min(w, h) / 2
      )
    );

    ctx.beginPath();

    ctx.moveTo(x + r, y);

    ctx.lineTo(
      x + w - r,
      y
    );

    ctx.quadraticCurveTo(
      x + w,
      y,
      x + w,
      y + r
    );

    ctx.lineTo(
      x + w,
      y + h - r
    );

    ctx.quadraticCurveTo(
      x + w,
      y + h,
      x + w - r,
      y + h
    );

    ctx.lineTo(
      x + r,
      y + h
    );

    ctx.quadraticCurveTo(
      x,
      y + h,
      x,
      y + h - r
    );

    ctx.lineTo(
      x,
      y + r
    );

    ctx.quadraticCurveTo(
      x,
      y,
      x + r,
      y
    );

    ctx.closePath();
  }

  circlePath(ctx, x, y, w, h) {
    ctx.beginPath();

    ctx.arc(
      x + w / 2,
      y + h / 2,
      Math.min(w, h) / 2,
      0,
      Math.PI * 2
    );
  }

  ovalPath(ctx, x, y, w, h) {
  ctx.beginPath();
  ctx.ellipse(
    x + w / 2,
    y + h / 2,
    w / 2,
    h / 2,
    0,
    0,
    Math.PI * 2
  );
}

  octagonPath(ctx, x, y, w, h) {
    const o = this.offset;

    ctx.beginPath();

    ctx.moveTo(
      x + o,
      y
    );

    ctx.lineTo(
      x + w - o,
      y
    );

    ctx.lineTo(
      x + w,
      y + o
    );

    ctx.lineTo(
      x + w,
      y + h - o
    );

    ctx.lineTo(
      x + w - o,
      y + h
    );

    ctx.lineTo(
      x + o,
      y + h
    );

    ctx.lineTo(
      x,
      y + h - o
    );

    ctx.lineTo(
      x,
      y + o
    );

    ctx.closePath();
  }

  oneCutPath(ctx, x, y, w, h, cut) {
    ctx.beginPath();

    ctx.moveTo(
      x,
      y
    );

    ctx.lineTo(
      x + w - cut,
      y
    );

    ctx.lineTo(
      x + w,
      y + cut
    );

    ctx.lineTo(
      x + w,
      y + h
    );

    ctx.lineTo(
      x,
      y + h
    );

    ctx.closePath();
  }

  traceShape(ctx) {
    const shape =
      this.data.shape ||
      "roundedRectangle";

    if (shape === "circle") {
      this.circlePath(
        ctx,
        this.x,
        this.y,
        this.w,
        this.h
      );

      return;
    }

    if (shape === "octagon") {
      this.octagonPath(
        ctx,
        this.x,
        this.y,
        this.w,
        this.h
      );

      return;
    }

    if (shape === "oneCut") {
      this.oneCutPath(
        ctx,
        this.x,
        this.y,
        this.w,
        this.h,
        this.cutOffset
      );

      return;
    }
    if (shape === "oval") {
    this.ovalPath(ctx, this.x, this.y, this.w, this.h);
    return;
  }

    this.roundedPath(
      ctx,
      this.x,
      this.y,
      this.w,
      this.h,
      this.r
    );
  }

  drawShadow() {
    const ctx = this.ctx;

    ctx.save();

    ctx.shadowColor =
      "rgba(0,0,0,.18)";

    ctx.shadowBlur = 16;
    ctx.shadowOffsetY = 8;

    this.traceShape(ctx);

    ctx.fillStyle = "#ffffff";
    ctx.fill();

    ctx.restore();
  }

  drawTop() {
    const ctx = this.ctx;

    const startX =
      Number.isFinite(this.x)
        ? this.x
        : 0;

    const startY =
      Number.isFinite(this.y)
        ? this.y
        : 0;

    const endY =
      Number.isFinite(this.h)
        ? startY + this.h
        : startY + 1;

    const gradient =
      ctx.createLinearGradient(
        startX,
        startY,
        startX,
        endY
      );

    gradient.addColorStop(
      0,
      "#59b8ff"
    );

    gradient.addColorStop(
      0.52,
      "#2f9cf4"
    );

    gradient.addColorStop(
      1,
      "#0f6dcc"
    );

    this.traceShape(ctx);

    ctx.fillStyle = gradient;
    ctx.fill();

    ctx.lineWidth = 2.5;
    ctx.strokeStyle = "#0d5aa9";

    ctx.stroke();
  }

  drawFold() {
    const fold =
      String(
        this.data.fold || ""
      )
        .toLowerCase()
        .trim();

    if (
      !fold ||
      fold === "none"
    ) {
      return;
    }

    const ctx = this.ctx;

    ctx.save();

    ctx.strokeStyle =
      "#d6d6d6";

    ctx.fillStyle =
      "#d6d6d6";

    ctx.lineWidth = 3;

    ctx.setLineDash([
      10,
      8
    ]);

    if (fold.includes("a")) {
        // Fold A: vertical line, top to bottom, splits Dimension A in half
        const foldX = this.x + this.w / 2;

        ctx.beginPath();
        ctx.moveTo(foldX, this.y);
        ctx.lineTo(foldX, this.y + this.h);
        ctx.stroke();

        ctx.setLineDash([]);
        ctx.save();
        ctx.translate(foldX - 10, this.y + this.h / 2);
        ctx.rotate(-Math.PI / 2);
        ctx.font = "600 16px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("Fold A", 0, 0);
        ctx.restore();
      }
      else if (fold.includes("b")) {
        // Fold B: horizontal line, left to right, splits Dimension B in half
        const foldY = this.y + this.h / 2;

        ctx.beginPath();
        ctx.moveTo(this.x, foldY);
        ctx.lineTo(this.x + this.w, foldY);
        ctx.stroke();

        ctx.setLineDash([]);
        ctx.font = "600 16px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";
        ctx.fillText("Fold B", this.x + this.w / 2, foldY - 8);
      }

    ctx.restore();
  }

  drawDimensions() {
    const shape =
      this.data.shape ||
      "roundedRectangle";

    if (shape === "circle") {
      this.drawCircleDimensions();
      return;
    }

    const ctx = this.ctx;

    ctx.save();

    ctx.strokeStyle =
      "#315cba";

    ctx.fillStyle =
      "#315cba";

    ctx.lineWidth = 2;

    ctx.font =
      "700 18px Arial";

    ctx.textAlign =
      "center";

    ctx.textBaseline =
      "middle";

    ctx.lineCap =
      "round";

    const guideDash = [
      6,
      7
    ];

    // =========================
    // A LENGTH
    // =========================

    const topGap =
      Math.min(
        35,
        Math.max(
          20,
          this.y - 10
        )
      );

    const topY =
      this.y - topGap;

    const startX =
      shape === "octagon"
        ? this.x + this.offset
        : this.x;

    const endX =
      shape === "octagon"
        ? this.x +
          this.w -
          this.offset
        : this.x +
          this.w;

    this.drawArrow(
      startX,
      topY,
      endX,
      topY,
      "#315cba"
    );

    ctx.setLineDash(
      guideDash
    );

    ctx.beginPath();

    ctx.moveTo(
      startX,
      this.y - 2
    );

    ctx.lineTo(
      startX,
      topY + 4
    );

    ctx.moveTo(
      endX,
      this.y - 2
    );

    ctx.lineTo(
      endX,
      topY + 4
    );

    ctx.stroke();

    ctx.setLineDash([]);

    const labelA =
      shape === "square"
        ? "A Side"
        : "A (Length)";

    ctx.fillText(
      `${this.number(
        this.data.A,
        0
      )}" ${labelA}`,

      (startX + endX) / 2,

      topY - 12
    );

    // =========================
    // B WIDTH
    // =========================

    if (shape !== "octagon") {
      const dimensionGap =
        Math.min(
          35,
          Math.max(
            20,
            this.x - 10
          )
        );

      const leftX =
        this.x -
        dimensionGap;

      this.drawArrow(
        leftX,
        this.y,
        leftX,
        this.y + this.h,
        "#315cba"
      );

      ctx.setLineDash(
        guideDash
      );

      ctx.beginPath();

      ctx.moveTo(
        leftX + 6,
        this.y
      );

      ctx.lineTo(
        this.x - 2,
        this.y
      );

      ctx.moveTo(
        leftX + 6,
        this.y + this.h
      );

      ctx.lineTo(
        this.x - 2,
        this.y + this.h
      );

      ctx.stroke();

      ctx.setLineDash([]);

      ctx.save();

      ctx.translate(
        leftX - 18,
        this.y +
          this.h / 2
      );

      ctx.rotate(
        -Math.PI / 2
      );

      ctx.textAlign =
        "center";

      ctx.textBaseline =
        "middle";

      ctx.fillText(
        `${this.number(
          this.data.B,
          0
        )}" B (Width)`,
        0,
        0
      );

      ctx.restore();
    }

    // =========================
    // C RADIUS
    // =========================

   if (
  shape ===
    "roundedRectangle" ||
  shape ===
    "roundedSquare"
) {
  const radiusCenterX =
    this.x +
    this.w -
    this.r * 0.95;

  const radiusCenterY =
    this.y +
    this.h -
    this.r * 0.95;

  // C circumference circle
  ctx.save();

  ctx.strokeStyle = "#d6d6d6"; // Same colour as Fold
  ctx.lineWidth = 3;

  ctx.beginPath();

  ctx.setLineDash([
    8,
    8
  ]);

  ctx.arc(
    radiusCenterX,
    radiusCenterY,
    this.r,
    0,
    Math.PI * 2
  );

  ctx.stroke();

  ctx.restore();

  // Reset back to normal dimension colour
  ctx.strokeStyle = "#315cba";
  ctx.fillStyle = "#315cba";
  ctx.lineWidth = 2;

  ctx.setLineDash([]);

  // C radius pointer line
  ctx.beginPath();

  ctx.moveTo(
    radiusCenterX -
      this.r * 0.7,
    radiusCenterY -
      this.r * 0.7
  );

  ctx.lineTo(
    radiusCenterX -
      this.r * 0.1,
    radiusCenterY -
      this.r * 0.1
  );

  ctx.stroke();

  ctx.textAlign =
    "left";

  ctx.textBaseline =
    "middle";

  ctx.fillText(
    `${this.number(
      this.data.C,
      0
    )}" C`,
    this.x +
      this.w +
      16,
    this.y +
      this.h -
      15
  );
}





    // =========================
    // OCTAGON B
    // =========================

    if (shape === "octagon") {
      const offset =
        this.offset;

      const cornerX =
        this.x +
        this.w;

      const cornerY =
        this.y;

      const cutStartX =
        cornerX -
        offset;

      const cutStartY =
        cornerY +
        offset;

      ctx.beginPath();

      ctx.setLineDash([
        6,
        7
      ]);

      ctx.moveTo(
        cutStartX,
        cornerY - 6
      );

      ctx.lineTo(
        cutStartX,
        cutStartY + 8
      );

      ctx.moveTo(
        cornerX + 6,
        cutStartY
      );

      ctx.lineTo(
        cutStartX - 8,
        cutStartY
      );

      ctx.stroke();

      ctx.setLineDash([]);

      ctx.beginPath();

      ctx.moveTo(
        cutStartX + 4,
        cutStartY - 4
      );

      ctx.lineTo(
        cornerX - 4,
        cornerY + 4
      );

      ctx.stroke();

      ctx.textAlign =
        "left";

      ctx.textBaseline =
        "middle";

      ctx.fillText(
        `${this.number(
          this.data.B,
          0
        )}" B`,
        this.x +
          this.w +
          16,
        this.y + 40
      );
    }

    // =========================
    // ONE CUT C
    // =========================

    if (shape === "oneCut") {
      const cut =
        this.cutOffset;

      const cornerX =
        this.x +
        this.w;

      const cornerY =
        this.y;

      const cutStartX =
        cornerX - cut;

      const cutStartY =
        cornerY + cut;

      ctx.beginPath();

      ctx.setLineDash([
        6,
        7
      ]);

      ctx.moveTo(
        cutStartX,
        cornerY - 6
      );

      ctx.lineTo(
        cutStartX,
        cutStartY + 8
      );

      ctx.moveTo(
        cornerX + 6,
        cutStartY
      );

      ctx.lineTo(
        cutStartX - 8,
        cutStartY
      );

      ctx.stroke();

      ctx.setLineDash([]);

      ctx.beginPath();

      ctx.moveTo(
        cutStartX + 4,
        cutStartY - 4
      );

      ctx.lineTo(
        cornerX - 4,
        cornerY + 4
      );

      ctx.stroke();

      ctx.textAlign =
        "left";

      ctx.textBaseline =
        "middle";

      ctx.fillText(
        `${this.number(
          this.data.C,
          0
        )}" C`,
        this.x +
          this.w +
          16,
        this.y + 40
      );
    }

    ctx.restore();
  }

  drawCircleDimensions() {
    const ctx = this.ctx;

    const centerX =
      this.x +
      this.w / 2;

    const arrowY =
      this.y +
      this.h +
      45;

    ctx.save();

    ctx.strokeStyle =
      "#315cba";

    ctx.fillStyle =
      "#315cba";

    ctx.lineWidth = 2;

    ctx.font =
      "700 18px Arial";

    ctx.textAlign =
      "center";

    ctx.textBaseline =
      "middle";

    ctx.lineCap =
      "round";

    this.drawArrow(
      this.x,
      arrowY,
      this.x + this.w,
      arrowY,
      "#315cba"
    );

    ctx.setLineDash([
      6,
      7
    ]);

    ctx.beginPath();

    ctx.moveTo(
      this.x,
      this.y + this.h
    );

    ctx.lineTo(
      this.x,
      arrowY - 4
    );

    ctx.moveTo(
      this.x + this.w,
      this.y + this.h
    );

    ctx.lineTo(
      this.x + this.w,
      arrowY - 4
    );

    ctx.stroke();

    ctx.setLineDash([]);

    ctx.fillText(
      `${this.number(
        this.data.A,
        0
      )}" A (Diameter)`,
      centerX,
      arrowY + 10
    );

    ctx.restore();
  }

  drawArrow(
    x1,
    y1,
    x2,
    y2,
    strokeStyle = "#555"
  ) {
    const ctx = this.ctx;

    ctx.beginPath();

    ctx.moveTo(
      x1,
      y1
    );

    ctx.lineTo(
      x2,
      y2
    );

    ctx.strokeStyle =
      strokeStyle;

    ctx.stroke();

    const drawHead =
      (x, y, angle) => {
        const size = 10;

        ctx.beginPath();

        ctx.moveTo(
          x,
          y
        );

        ctx.lineTo(
          x -
            size *
            Math.cos(
              angle -
                Math.PI / 6
            ),
          y -
            size *
            Math.sin(
              angle -
                Math.PI / 6
            )
        );

        ctx.lineTo(
          x -
            size *
            Math.cos(
              angle +
                Math.PI / 6
            ),
          y -
            size *
            Math.sin(
              angle +
                Math.PI / 6
            )
        );

        ctx.closePath();

        ctx.fillStyle =
          strokeStyle;

        ctx.fill();
      };

    const angle =
      Math.atan2(
        y2 - y1,
        x2 - x1
      );

    drawHead(
      x2,
      y2,
      angle
    );

    drawHead(
      x1,
      y1,
      angle + Math.PI
    );
  }
}